import { CheckIcon, ErrorIcon, WarningIcon } from './icons';

const feedbacksConfiguration = {
  success: {
    icon: CheckIcon,
    color: 'bg-custom-success-color',
  },
  warning: {
    icon: WarningIcon,
    color: 'bg-custom-warning-color',
  },
  error: {
    icon: ErrorIcon,
    color: 'bg-custom-error-color',
  },
};

export default feedbacksConfiguration;
